import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => (
  <footer className="bg-void-black border-t border-grid-line py-16">
    <div className="container mx-auto max-w-7xl px-6">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
        <FooterCol title="Services">
          <Link to="/services#plan" className="footer-link">Plan</Link>
          <Link to="/services#embed" className="footer-link">Embed</Link>
          <Link to="/services#handoff" className="footer-link">Hand-off</Link>
          <Link to="/services" className="footer-link">All three modes</Link>
        </FooterCol>
        <FooterCol title="Resources">
          <Link to="/why" className="footer-link">Why Parsant</Link>
          <Link to="/how-we-work" className="footer-link">How we work</Link>
          <Link to="/quiz" className="footer-link">Start AI Readiness Assessment</Link>
          <Link to="/faq" className="footer-link">FAQ</Link>
        </FooterCol>
        <FooterCol title="Get in touch">
          <a href="mailto:chris@parsant.com" className="footer-link">chris@parsant.com</a>
        </FooterCol>
        <FooterCol title="Parsant">
          <a href="https://terminal.parsant.com" className="footer-link" target="_blank" rel="noreferrer">Terminal</a>
        </FooterCol>
      </div>

      <div className="border-t border-grid-line pt-8 flex flex-col items-center gap-4">
        <img src="/parsant-logo-full-stacked-white.svg" alt="Parsant" className="h-16 opacity-80" />
        <div className="font-mono text-xs text-steel uppercase tracking-[0.15em]">© 2026 Parsant. All rights reserved.</div>
      </div>
    </div>
  </footer>
);

const FooterCol: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (
  <div className="flex flex-col gap-2">
    <div className="font-mono text-xs text-command-amber uppercase tracking-[0.15em] mb-2">{title}</div>
    {children}
  </div>
);

export default Footer;
